import { lazy, useState } from 'react';
import withSuspense from '../../../helpers/withSuspense.jsx';
import Portal from '../../common/Portal.jsx';
import SkeletonGrid from '../../../skeleton_loaders/common/SkeletonGrid.jsx';

const ShowWorkPackageDialog = withSuspense(lazy(() => import('./ShowWorkPackageDialog.jsx'), <SkeletonGrid gridHeight={420} />));

function ShowWorkPackageLink({ triggerLabel, work_package_id, projectId, permissions }) {
  const [open, setOpen] = useState(false);

  const portalProps = {
    component: ShowWorkPackageDialog,
    projectId,
    label: triggerLabel,
    permissions,
    work_package_id,
    onClose: () => setOpen(false)
  };
  return (<>
    {open && <Portal
      {...portalProps}
    />}
    <a style={{cursor: 'pointer'}} onClick={() => setOpen(true)}>
      {triggerLabel}
    </a>
  </>);
}

export default ShowWorkPackageLink;
